import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";

function ModalEditTime2({ show, onHide, submitClick = () => {}, id = null, currentTime = "" }) {
  const [val, setVal] = useState("");

  // Sync state ketika modal dibuka
  useEffect(() => {
    if (show) {
      setVal(currentTime || "");
    } else {
      setVal("");
    }
  }, [show, currentTime]);

  const handleChange = (e) => {
    setVal(e.target.value);
  };

  const handleSubmit = () => {
    if (!val) return;
    submitClick({ id, val });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <ModalHeader closeButton>
        <h5 className="modal-title">Edit Time</h5>
      </ModalHeader>

      <ModalBody>
        <div className="mb-3">
          <input type="time" value={val} onChange={handleChange} className="form-control" />
        </div>

        <div className="alert bg-inverse bg-opacity-15">Please edit time</div>
      </ModalBody>

      <ModalFooter>
        <button type="button" disabled={!val} onClick={handleSubmit} className="btn btn-outline-theme">
          Save changes
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalEditTime2;
